"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("./CustomPropTypes/CustomPropTypes"));

var _reactFoco = _interopRequireDefault(require("react-foco"));

var _modalManager = require("./modalManager");

var _keycode = _interopRequireDefault(require("keycode"));

var _PopperContainer = _interopRequireDefault(require("./_PopperContainer"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactPopper = require("react-popper");

var _constants = require("./constants");

var _popover = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/popover.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _popover.default);
var defaultModifiers = [{
  name: 'computeStyle',
  phase: 'main',
  options: {
    gpuAcceleration: false
  }
}, {
  name: 'preventOverflow'
}, {
  name: 'hide' // adds the isReferenceHidden attribute

}];

var createFlipModifier = function createFlipModifier(_ref) {
  var disableEdgeDetection = _ref.disableEdgeDetection,
      popperPlacement = _ref.popperPlacement,
      flipContainer = _ref.flipContainer;

  if (disableEdgeDetection) {
    return {
      name: 'flip',
      enabled: false
    };
  }

  var options = {
    boundary: flipContainer
  };

  if ((0, _isArray.default)(popperPlacement)) {
    options.fallbackPlacements = (0, _slice.default)(popperPlacement).call(popperPlacement, 1);
  }

  return {
    name: 'flip',
    options: options
  };
};

var matchTargetModifier = {
  name: 'matchTargetModifier',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: function fn(_ref2) {
    var state = _ref2.state;
    state.styles.popper.width = "".concat(state.rects.reference.width, "px");
  },
  effect: function effect(_ref3) {
    var state = _ref3.state;
    state.elements.popper.style.width = "".concat(state.elements.reference.offsetWidth, "px");
  }
};
var minTargetModifier = {
  name: 'minTargetModifier',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: function fn(_ref4) {
    var state = _ref4.state;
    state.styles.popper.minWidth = "".concat(state.rects.reference.width, "px");
  },
  effect: function effect(_ref5) {
    var state = _ref5.state;
    state.elements.popper.style.minWidth = "".concat(state.elements.reference.offsetWidth, "px");
  }
};
var maxTargetModifier = {
  name: 'maxTargetModifier',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: function fn(_ref6) {
    var state = _ref6.state;
    state.styles.popper.maxWidth = "".concat(state.rects.reference.width, "px");
  },
  effect: function effect(_ref7) {
    var state = _ref7.state;
    state.elements.popper.style.maxWidth = "".concat(state.elements.reference.offsetWidth, "px");
  }
};

var Popper = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Popper, _React$Component);

  var _super = _createSuper(Popper);

  function Popper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Popper);
    _this = _super.call(this, props);

    _this._handleDocumentKeyDown = function (e) {
      if (_this.modalManager.isTopModal((0, _assertThisInitialized2.default)(_this))) {
        _this.props.onKeyDown(e);

        if (e.keyCode === _keycode.default.codes.esc && _this.props.onEscapeKey) {
          e.preventDefault();
          e.stopPropagation();

          _this.props.onEscapeKey();
        }
      }
    };

    _this.modalManager = props.modalManager ? props.modalManager : (0, _modalManager.getModalManager)();
    return _this;
  }

  (0, _createClass2.default)(Popper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.show) {
        this._onShow();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.show && !this.props.show) {
        this._onHide();
      } else if (!prevProps.show && this.props.show) {
        this._onShow();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.show) {
        this._onHide();
      }
    }
  }, {
    key: "_onShow",
    value: function _onShow() {
      var container = _reactDom.default.findDOMNode(this) || document.body;
      this.modalManager.add(this, container);
      document.addEventListener('keydown', this._handleDocumentKeyDown);
    }
  }, {
    key: "_onHide",
    value: function _onHide() {
      this.modalManager.remove(this);
      document.removeEventListener('keydown', this._handleDocumentKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _context;

      var _this$props = this.props,
          children = _this$props.children,
          cssBlock = _this$props.cssBlock,
          disableEdgeDetection = _this$props.disableEdgeDetection,
          flipContainer = _this$props.flipContainer,
          innerRef = _this$props.innerRef,
          innerRefClassName = _this$props.innerRefClassName,
          noArrow = _this$props.noArrow,
          onClickOutside = _this$props.onClickOutside,
          popperClassName = _this$props.popperClassName,
          popperModifiers = _this$props.popperModifiers,
          popperPlacement = _this$props.popperPlacement,
          popperProps = _this$props.popperProps,
          referenceClassName = _this$props.referenceClassName,
          referenceComponent = _this$props.referenceComponent,
          referenceProps = _this$props.referenceProps,
          show = _this$props.show,
          usePortal = _this$props.usePortal,
          widthSizingType = _this$props.widthSizingType;
      var modifiers = (0, _concat.default)(_context = []).call(_context, defaultModifiers, [createFlipModifier({
        disableEdgeDetection: disableEdgeDetection,
        popperPlacement: popperPlacement,
        flipContainer: flipContainer
      })], (0, _toConsumableArray2.default)(popperModifiers));

      if (widthSizingType === 'matchTarget') {
        modifiers.push(matchTargetModifier);
      }

      if (widthSizingType === 'minTarget') {
        modifiers.push(minTargetModifier);
      }

      if (widthSizingType === 'maxTarget') {
        modifiers.push(maxTargetModifier);
      }

      var popperClasses = classnames("".concat(cssBlock, "__popper"), popperClassName, (0, _defineProperty2.default)({}, "".concat(cssBlock, "__popper--no-arrow"), !!noArrow));
      var basePlacement = (0, _isArray.default)(popperPlacement) ? popperPlacement[0] : popperPlacement;

      var popper = /*#__PURE__*/_react.default.createElement(_reactPopper.Popper, {
        modifiers: modifiers,
        placement: basePlacement
      }, function (_ref8) {
        var ref = _ref8.ref,
            style = _ref8.style,
            isReferenceHidden = _ref8.isReferenceHidden,
            arrowProps = _ref8.arrowProps,
            placement = _ref8.placement;

        if (!show) {
          return null;
        } // TODO: Temporary overrides to support popper-2


        var fundamentalStyleOverrides = {
          visibility: isReferenceHidden ? 'hidden' : 'visible'
        };
        var fundamentalStyleArrowOverrides = {
          margin: 0
        };
        return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, popperProps, {
          className: popperClasses,
          ref: ref,
          style: _objectSpread(_objectSpread(_objectSpread({}, style), popperProps.style), fundamentalStyleOverrides) // eslint-disable-next-line no-undefined
          ,
          "x-out-of-boundaries": isReferenceHidden ? 'true' : undefined // This is needed for fundamental-styles even though popper-2 uses data-placement as well
          ,
          "x-placement": placement
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: classnames("".concat(cssBlock, "__innerRef"), innerRefClassName),
          ref: innerRef
        }, children), /*#__PURE__*/_react.default.createElement("span", {
          className: classnames("".concat(cssBlock, "__arrow")),
          ref: arrowProps.ref,
          style: _objectSpread(_objectSpread({}, arrowProps.style), fundamentalStyleArrowOverrides)
        }));
      });

      if (usePortal) {
        popper = /*#__PURE__*/_react.default.createElement(_PopperContainer.default, null, popper);
      }

      return /*#__PURE__*/_react.default.createElement(_reactPopper.Manager, null, /*#__PURE__*/_react.default.createElement(_reactFoco.default, {
        component: "div",
        onClickOutside: onClickOutside
      }, /*#__PURE__*/_react.default.createElement(_reactPopper.Reference, null, function (_ref9) {
        var ref = _ref9.ref;
        return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, referenceProps, {
          className: referenceClassName,
          ref: ref
        }), referenceComponent);
      }), popper));
    }
  }]);
  return Popper;
}(_react.default.Component);

Popper.displayName = 'Popper';
process.env.NODE_ENV !== "production" ? Popper.propTypes = {
  children: _propTypes.default.node.isRequired,
  cssBlock: _propTypes.default.string.isRequired,
  referenceComponent: _propTypes.default.element.isRequired,
  disableEdgeDetection: _propTypes.default.bool,
  flipContainer: _CustomPropTypes.default.elementOrArrayOfElements(),
  innerRef: _propTypes.default.func,
  innerRefClassName: _propTypes.default.string,
  modalManager: _propTypes.default.object,
  noArrow: _propTypes.default.bool,
  popperClassName: _propTypes.default.string,
  popperModifiers: _propTypes.default.array,
  popperPlacement: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOf(_constants.POPPER_PLACEMENTS)), _propTypes.default.oneOf(_constants.POPPER_PLACEMENTS)]),
  popperProps: _propTypes.default.object,
  referenceClassName: _propTypes.default.string,
  referenceProps: _propTypes.default.object,
  show: _propTypes.default.bool,
  usePortal: _propTypes.default.bool,
  widthSizingType: _propTypes.default.oneOf(_constants.POPPER_SIZING_TYPES),
  onClickOutside: _propTypes.default.func,
  onEscapeKey: _propTypes.default.func,
  onKeyDown: _propTypes.default.func
} : void 0;
Popper.defaultProps = {
  popperModifiers: [],
  popperPlacement: ['bottom-start', 'top-start', 'bottom-end', 'top-end'],
  onClickOutside: function onClickOutside() {},
  onKeyDown: function onKeyDown() {}
};
var _default = Popper;
exports.default = _default;